import React from 'react';

/**
 * A simple, reusable component to display an error message in a styled box.
 * @param {object} props - The properties passed to the component.
 * @param {string} props.message - The error message to display.
 * @returns {JSX.Element}
 */
const ErrorMessage = ({ message }) => (
    <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg relative my-4" role="alert">
        <strong className="font-bold">Error: </strong>
        <span className="block sm:inline">{message}</span>
    </div>
);

export default ErrorMessage;
